module.exports = __webpack_public_path__ + "static/profile-pic-f1435deb02afbfffe9b927df83d89c7b.jpg";